import { useCallback, useEffect, useRef, useState } from 'react';

export default function useDimensions() {
  const [dimensions, setDimensions] = useState();
  const observer = useRef(null);
  const refNode = useRef(null);

  const callbackRef = useCallback((node) => {
    if (node !== null) {
      refNode.current = node;
      setDimensions(node.getBoundingClientRect().toJSON());

      observer.current = new ResizeObserver(() => {
        setDimensions(node.getBoundingClientRect().toJSON());
      });
      observer.current.observe(node);
    }
  }, []);

  useEffect(() => () => {
    if (refNode.current) {
      observer.current.unobserve(refNode.current);
    }
  }, []);

  return {
    ...dimensions,
    callbackRef,
  };
}
